export default function Container({ children }) {
  return (
    <div className="container wrapper-sm wrapper">
      <div className="col-md-8 mx-auto col-12">{children}</div>
    </div>
  );
}
